import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, CardHeader } from '@mui/material';
import T from 'prop-types';
import { NotifyIcon, NotifyTypo } from 'web-components';
import { IrisBatchTargetPropTypes } from '../../../../../../helpers/propTypes';
import IrisBatchRecordsEditTargetPLC from '../../IrisBatchRecordsEditModal/IrisBatchRecordsEditTargetPLC';

const labelAmend = 'machines.machine_details.batch_iris.target';
const labelAmendItem = `${labelAmend}.plc_target_label`;

const IrisBatchTargetPLC = ({ target, machineId, plcType }) => {
  const { t } = useTranslation();
  const [editModal, setEditModal] = useState(false);
  const handleClose = () => setEditModal(false);

  const defaultTarget = target?.plc_target;

  return (
    <>
      <CardHeader
        sx={{ p: 0, alignItems: 'flex-start', mb: 0 }}
        action={
          <Button
            variant="text"
            sx={{ p: 1.5, gap: 1, display: 'flex', height: '50px', width: '96px' }}
            onClick={() => setEditModal(true)}
          >
            <NotifyIcon iconName="edit" fontSize="medium" />
            {t(`machines.machine_details.edit`)}
          </Button>
        }
        title={
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ mt: '15px', fontSize: '16px' }}>{t(`${labelAmend}.title`)}</Box>
          </Box>
        }
        titleTypographyProps={{
          fontWeight: '500',
          variant: 'Body1'
        }}
      />
      <NotifyTypo.Subtitle1 fontWeight="400">{t(`${labelAmend}.subtitle`)}</NotifyTypo.Subtitle1>
      <Box display="grid" gridTemplateColumns="repeat(10, 1fr)" gap={2} sx={{ mt: 3, mb: 4 }}>
        <Box gridColumn="span 10">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmendItem}.target_type_address`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>
            {!defaultTarget?.grinding_target_type_address ? '---' : defaultTarget?.grinding_target_type_address}
          </NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 2">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmendItem}.time_value`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>{!defaultTarget?.time_value ? '---' : defaultTarget?.time_value}</NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 2">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmendItem}.time_address_h`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>
            {!defaultTarget?.time_address_hours ? '---' : defaultTarget?.time_address_hours}
          </NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 6">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmendItem}.time_address_m`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>
            {!defaultTarget?.time_address_minutes ? '---' : defaultTarget?.time_address_minutes}
          </NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 2">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmendItem}.grinding_energy_value`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>
            {!defaultTarget?.specific_grinding_energy_value ? '---' : defaultTarget?.specific_grinding_energy_value}
          </NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 8">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmendItem}.energy_add`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>
            {!defaultTarget?.specific_grinding_energy_address ? '---' : defaultTarget?.specific_grinding_energy_address}
          </NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 2">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmendItem}.energy_value`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>
            {!defaultTarget?.grinding_energy_value ? '---' : defaultTarget?.grinding_energy_value}
          </NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 8">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmendItem}.energy_address`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>
            {!defaultTarget?.grinding_energy_address ? '---' : defaultTarget?.grinding_energy_address}
          </NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 2">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmendItem}.number_cycles_value`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>
            {!defaultTarget?.number_of_cycles_value ? '---' : defaultTarget?.number_of_cycles_value}
          </NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 8">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmendItem}.cycles_address`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>
            {!defaultTarget?.number_of_cycles_address ? '---' : defaultTarget?.number_of_cycles_address}
          </NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 2">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmendItem}.rate_value`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>
            {!defaultTarget?.production_rate_value ? '---' : defaultTarget?.production_rate_value}
          </NotifyTypo.Body1>
        </Box>
        <Box gridColumn="span 8">
          <NotifyTypo.InfoText fontWeight="400">{t(`${labelAmendItem}.rate_address`)}</NotifyTypo.InfoText>
          <NotifyTypo.Body1>
            {!defaultTarget?.production_rate_address ? '---' : defaultTarget?.production_rate_address}
          </NotifyTypo.Body1>
        </Box>
      </Box>

      <IrisBatchRecordsEditTargetPLC
        open={editModal}
        handleClose={handleClose}
        data={defaultTarget}
        machineId={machineId}
        plcType={plcType}
      />
    </>
  );
};

IrisBatchTargetPLC.propTypes = {
  target: IrisBatchTargetPropTypes,
  machineId: T.string.isRequired,
  plcType: T.shape({
    plc_type: T.string,
    autoconfig_enabled: T.bool
  }).isRequired
};

IrisBatchTargetPLC.defaultProps = {
  target: null
};

export default IrisBatchTargetPLC;
